import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Button } from '@mui/material'
import { useDrillDownModalOnClose } from 'utils'
import { useNavigate } from 'react-router-dom'
import { useEnabledFeatureToggleList, useSelectedPremiumFleets } from 'features/settings'
import { useLatestFbtSubmission } from 'features/fbt/navigation-config'
import { fetchRelatedFbt } from '../../../actions'

// views
import FbtTable from './fbt-table'
import { FbtRoiForm } from 'features/fbt'

const FBT = ({ data, relatedFbt, onFetchRelatedFbt }) => {
  const navigate = useNavigate()
  const mobileView = useMediaQuery('(max-width: 600px)')
  const fbtFleets = useSelectedPremiumFleets()

  const latestFbtSubmission = useLatestFbtSubmission()
  const onClose = useDrillDownModalOnClose()

  const featureToggleList = useEnabledFeatureToggleList()
  const fbtFeatureToggle = featureToggleList.includes('FBT')

  const isFBTCustomer =
    fbtFeatureToggle &&
    fbtFleets.some(item => item.value === data.thirdPartyNumber)

  const onEdit = () => {
    if (latestFbtSubmission?.link) {
      navigate(latestFbtSubmission.link)
    }
  }

  useEffect(() => {
    if (data?.registration) {
      onFetchRelatedFbt(data.registration)
    }
  }, [data?.registration]) // eslint-disable-line

  if (!fbtFeatureToggle) {
    return null
  }

  return (
    <>
      {isFBTCustomer ? <FbtTable data={relatedFbt} /> : <FbtRoiForm />}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {isFBTCustomer && (
          <Button
            fullWidth={mobileView}
            color="primary"
            sx={{ mt: 2, mr: 2, minWidth: 180 }}
            variant="contained"
            onClick={onEdit}>
            Edit
          </Button>
        )}
        <Button
          fullWidth={mobileView}
          sx={{ mt: 2, mr: 2, minWidth: 180 }}
          variant="contained"
          onClick={onClose}>
          Close
        </Button>
      </div>
    </>
  )
}

FBT.propTypes = {
  data: PropTypes.object.isRequired,
  relatedFbt: PropTypes.object,
  onFetchRelatedFbt: PropTypes.func.isRequired,
}

/* ---------- Container wrapper ---------- */

const FBTContainer = (props) => {
  const { id } = useParams()
  return <ConnectedFBT {...props} routeId={id} />
}

const mapStateToProps = ({ fleet }, { routeId }) => ({
  data: fleet.data?.[routeId],
  relatedFbt: fleet.relatedFbt,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchRelatedFbt: (rego) =>
    dispatch(fetchRelatedFbt(null, { resourceId: rego })),
})

const ConnectedFBT = connect(
  mapStateToProps,
  mapDispatchToProps
)(FBT)

export default FBTContainer
